import { render, staticRenderFns } from "./course-modal.vue?vue&type=template&id=21591013&scoped=true"
import script from "./course-modal.vue?vue&type=script&lang=js"
export * from "./course-modal.vue?vue&type=script&lang=js"
import style0 from "./course-modal.vue?vue&type=style&index=0&id=21591013&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21591013",
  null
  
)

export default component.exports